import React from 'react';
import { playHover } from '../../../utils/sounds';
import './footer.css';

const LINKS = [
  { label: 'EMAIL', href: 'mailto:amrinderbhogal06@gmail.com', external: false },
  { label: 'LINKEDIN', href: 'https://www.linkedin.com/in/amrinderb', external: true },
  { label: 'GITHUB', href: 'https://github.com/Amrinder-B', external: true },
  { label: 'B&B TECHNOSOL', href: 'https://bbtechnosol.com/', external: true },
  { label: 'B&B REALTY', href: 'https://www.bbrealtyrenos.com/', external: true },
];

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="crt-footer" role="contentinfo">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <span className="fb-bracket">[</span>
            <span className="fb-name">AMRINDER BHOGAL</span>
            <span className="fb-bracket">]</span>
          </div>

          <div className="footer-links">
            {LINKS.map((lnk) => (
              <a
                key={lnk.label}
                href={lnk.href}
                target={lnk.external ? '_blank' : undefined}
                rel={lnk.external ? 'noopener noreferrer' : undefined}
                className="footer-link"
                onMouseEnter={playHover}
              >
                {lnk.label}
              </a>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <span className="footer-copy">
            &copy; {year} AMRINDER BHOGAL &mdash; ALL RIGHTS RESERVED
          </span>
          <span className="footer-sys">
            SYS: PORTFOLIO_OS v2.0 &bull; STATUS: ONLINE
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
